module.exports = __webpack_public_path__ + "img/ds11.b9bc5e07.png";